import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=d23a098c&scoped=true"
import script from "./Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Products.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=d23a098c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a098c",
  null
  
)

export default component.exports